import httpServices from 'services/http.service';
import { API_URLS } from 'config/constants';

export const getProvideProducts = (provider: string) => (
  httpServices.get(API_URLS.PROVIDER.PRODUCTS, { params: { provider } })
);

export const getProviders = () => httpServices.get(API_URLS.PROVIDER.ALL);
